import React, { useState } from "react";
import "./Contact.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch("http://localhost:8000/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          company_name: form.company,
          message: form.message,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus(
          `Message sent successfully! Reference ID: ${result.contact_id}`
        );

        setForm({
          name: "",
          email: "",
          company: "",
          message: "",
        });
      } else {
        setStatus(result.message || "Failed to send message.");
      }
    } catch (err) {
      console.error(err);
      setStatus("Unable to connect to the server.");
    }
  };

  return (
    <section id="contact" className="contact-section">

      <div className="contact-header">

        <h5>CONTACT US</h5>

        <h2>Let's Build Something Amazing Together</h2>

        <p>
          Have an idea or need an experienced technology partner?
          We'd love to discuss your project.
        </p>

      </div>

      <div className="contact-wrapper">

        <div className="contact-info">

          <div className="info-box">
            <FaMapMarkerAlt />
            <div>
              <h4>Office</h4>
              <p>Nagpur, Maharashtra, India</p>
            </div>
          </div>

          <div className="info-box">
            <FaPhoneAlt />
            <div>
              <h4>Phone</h4>
              <p>+91 9422110467</p>
            </div>
          </div>

          <div className="info-box">
            <FaEnvelope />
            <div>
              <h4>Email</h4>
              <p>info@eforumsystems.com</p>
            </div>
          </div>

          <div className="info-box">
            <FaClock />
            <div>
              <h4>Working Hours</h4>
              <p>Mon - Fri | 9 AM - 6 PM</p>
            </div>
          </div>

        </div>

        <form className="contact-form" onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="company"
            placeholder="Company Name"
            value={form.company}
            onChange={handleChange}
          />

          <textarea
            rows="6"
            name="message"
            placeholder="Tell us about your project..."
            value={form.message}
            onChange={handleChange}
            required
          />

          <button type="submit">
            Send Message →
          </button>

          <p className="status">{status}</p>

        </form>

      </div>

    </section>
  );
}